$(document).ready(function () {

    if ($(".Links_list").length > 0) {
        // Select the source div elements by class
        $('.Section_heading').each(function (index) {
            var sourceText = $(this).text();
            var dataSecId = $(this).attr("data-id");
            $('#targetDiv').append('<li data-id="' + dataSecId + '">' + sourceText + '</li>');
        });
        $('.Links_list li:first-child').addClass('activated');
        var secondLi = $('.Links_list li:eq(1)'); // Select the second li element (index 1)

        if (secondLi.length > 0) {
            var secondLiText = secondLi.text();
            var secondLiDataId = secondLi.attr('data-id');

            // Set the text and data-id for the nextItem on page load
            $(".nextItem").show();
            $(".nextItem span.bottom-nav-text").text(secondLiText);
            $('.nextItem span.bottom-nav-text').attr('data-id', secondLiDataId);
        }

        $('.Links_list li').click(function () {
            var needToActiveSec = $(this).attr("data-id");
            var nextTabBtn = $(this).next("li");
            var nextTabId = $(this).next("li").attr("data-id");
            var prevTabBtn = $(this).prev("li");
            var prevTabId = $(this).prev("li").attr("data-id");
            $('.Links_list li').removeClass('activated');
            $(this).addClass('activated');
            $(".mainTabSec").hide();
            $(needToActiveSec).fadeIn(300);
            $(".nextItem").hide();
            $(".previousItem").hide();
            if (nextTabBtn.length > 0 && $.trim(nextTabBtn.text()) !== '') {
                $(".nextItem").show();
                $(".nextItem span.bottom-nav-text").text(nextTabBtn.text());
                $('.nextItem span.bottom-nav-text').attr('data-id', nextTabId);
                console.log(nextTabBtn);
            }
            else {
                $(".nextItem").hide();
            }
            if (prevTabBtn.length > 0 && $.trim(prevTabBtn.text()) !== '') {
                $(".previousItem").show();
                $(".previousItem span.bottom-nav-text").text(prevTabBtn.text());
                $('.previousItem span.bottom-nav-text').attr('data-id', prevTabId);
            }
            else {
                $(".previousItem").hide();
            }

        });
        $(".tabNavItems").click(function () {
            console.log("working");
            var dataIdValue = $(this).children(".bottom-nav-text").attr("data-id");
            console.log(dataIdValue);
            var matchingLi = $('li[data-id="' + dataIdValue + '"]');
            matchingLi.click();
        });
    }


});